import { FileObject } from "react-mui-dropzone";

export enum FileDataType {
    IMAGE = "image",
    TEXT = "text",
    OTHER = "other",
    PDF = "pdf",
}

export class FileData {
    fileName: string;
    data: ArrayBuffer;
    fileType: FileDataType;

    constructor(fileName: string, data: ArrayBuffer, fileType?: FileDataType) {
        this.fileName = fileName;
        if (fileType) {
            this.fileType = fileType;
        } else {
            if (FileData.isImage(fileName)) this.fileType = FileDataType.IMAGE;
            else if (FileData.isText(fileName)) this.fileType = FileDataType.TEXT;
            else if (FileData.isPDF(fileName)) this.fileType = FileDataType.PDF;
            else this.fileType = FileDataType.OTHER;
        }
        this.data = data;
    }

    static async fromFile(file: File): Promise<FileData> {
        return new FileData(file.name, await file.arrayBuffer());
    }
    static fromFileObject(file: FileObject): FileData {
        return new FileData(file.file.name, file.data as ArrayBuffer);
    }

    toFile(): File {
        return new File([this.data], this.fileName);
    }

    toFileObject(): FileObject {
        return { file: this.toFile(), data: this.data };
    }

    getDataAsBlob(): Blob {
        return new Blob([this.data]);
    }

    static isImage(fileName: string): boolean {
        return (
            fileName.endsWith(".png") ||
            fileName.endsWith(".jpg") ||
            fileName.endsWith(".jpeg") ||
            fileName.endsWith(".gif")
        );
    }

    static isText(fileName: string): boolean {
        return fileName.endsWith(".txt") || fileName.endsWith(".md");
    }

    static isPDF(fileName: string): boolean {
        return fileName.endsWith(".pdf");
    }
}
